import { analyticService } from 'global/services';

const romanticVideoSliderContainerNode = document.querySelector('#romanticVideoSliderContainer');

export const handleRomanticVideoSliderClick = () => {
    const handleVideoSliderClick = () => {
        analyticService.push({ eventName: 'Video_Click', sourceName: 'romantic' });
    };
    if (romanticVideoSliderContainerNode) {
        romanticVideoSliderContainerNode.addEventListener('click', handleVideoSliderClick);
    }
};
